import { common, createI18n, I18nProvider, iam } from '@bino/utils/i18next';
import { Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import type { SignUpProps } from './pages/signUp/signUp';
import { SignUp } from './pages/signUp/signUp';
import type { VerificationProps } from './pages/verification/verification';
import { Verification } from './pages/verification/verification';

const i18n = createI18n(common, iam);

export const renderVerification = (id: string, props: VerificationProps) => {
    const container = document.getElementById(id);
    if (!container) return;

    const root = createRoot(container);
    root.render(
        <Suspense>
            <I18nProvider i18n={i18n}>
                <Verification {...props} />
            </I18nProvider>
        </Suspense>,
    );
};

export const renderSignUp = (id: string, props: SignUpProps) => {
    const container = document.getElementById(id);
    if (!container) return;

    const root = createRoot(container);
    root.render(
        <Suspense>
            <I18nProvider i18n={i18n}>
                <SignUp {...props} />
            </I18nProvider>
        </Suspense>,
    );
};

const api = { renderVerification, renderSignUp };

declare global {
    // eslint-disable-next-line no-var
    var AuthCatalogApp: typeof api;
}

globalThis.AuthCatalogApp = api;
